export default "__VITE_ASSET__BXq9cbCT__"